import { render } from "./ContractLabor.vue?vue&type=template&id=a1d02cb8&scoped=true&ts=true"
import script from "./ContractLabor.vue?vue&type=script&lang=ts"
export * from "./ContractLabor.vue?vue&type=script&lang=ts"

import "./ContractLabor.vue?vue&type=style&index=0&id=a1d02cb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d02cb8"]])

export default __exports__